<template>
  <main>



    <div id="modal1" class="modal">
      <div class="modal-content">
        <table>
          <thead>
            <tr>
              <th v-for="titulo in titulosTabla">{{ titulo }}</th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="fila in contenidoTabla">
              <td v-for="elemento in fila">
                <span v-if="elemento.isCorrecto">{{ elemento.valor }}</span
                ><span v-if="!elemento.isCorrecto" class="rojo">{{
                  elemento.valor
                }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="modal-footer">
        <a href="#!" class="modal-close waves-effect waves-green btn-flat"
          >Cerrar</a
        >
      </div>
    </div>
    <div class="main-container">
      <div class="row center-align">
        <div class="col s12 m8 l6  push-m2 push-l3 card-panel">
          <div class="padding-superior padding-laterales">
            <div class="row">
              <div class="col s10 offset-s1">
                <div class="page-title">
                  <span>Subir archivos</span>
                </div>

                <!--              <div class="card-image">-->

                <!--                <form-->
                <!--                  style="display: flex; flex-wrap: wrap; flex-grow: 1; flex-basis: 200;"-->
                <!--                  enctype="multipart/form-data"-->
                <!--                  id="plantilla"-->
                <!--                  class="form-subir-archivos"-->
                <!--                  @submit.prevent="enviarArchivo"-->
                <!--                ></form>-->
                <!--              </div>-->
                <form

                    enctype="multipart/form-data"
                    id="plantilla"
                    class="form-subir-archivos"
                    @submit.prevent="showModal('enviarArchivo')"
                >
                  <div class="card-content">
                    <div class="input-field">
                      <select v-model="accion">
                        <option value="0" selected disabled>Selecciona una acción</option>
                        <option value="1" v-if="isAdmin && fIsControler('Registrar nuevos')">Registrar nuevos </option>
                        <option value="2" v-if="isAdmin && fIsControler('Reemplazar')">Reemplazar</option>
                        <option value="3" v-if="isAdmin && fIsControler('Eliminar')">Eliminar</option>
                        <option value="4" v-if="permisoRecargas && isAdmin && fIsControler('Recargas Masivas')"
                        >Recargas Masivas </option
                        >
                        <option value="6" v-if="permisoPortabilidades && isAdmin && fIsControler('Nuevas Portabilidades')"
                        >Nuevas Portabilidades</option
                        >
                        <!--                    <option value="5" v-if="!isAdmin">Retroalimentacion</option>-->
                        <option value="7" v-if="isAdmin && fIsControler('Registrar Usuarios')">Registrar Usuarios</option>
                        <option value="9" v-if="isAdmin && permisoAgendadas && fIsControler('Recargas Agendadas')">Recargas Agendadas</option>
                      </select>
                      <label>Selecciona una acción</label>
                    </div>
                    <div
                        class="card-content"
                        v-show="permiso & (accion == 1 || accion == 2)"
                    >
                      <div class="input-field">
                        <select v-model="plataforma">
                          <option value="" selected> No aplica</option>
                          <option
                              v-for="plataforma in plataformas"
                              :value="plataforma.id"
                          >{{ plataforma.usuario }} ({{ plataforma.plataforma }})
                          </option>
                        </select>
                        <label>Plataforma</label>
                      </div>
                    </div>

                    <div
                        v-if="(accion === '1' || accion === '2') && isAdmin"
                        class="input-field"
                    >
                      <input id="input-vigencia" type="text" class="datepicker" />
                      <label for="input-vigencia">Vigencia</label>
                    </div>
                    <div
                        class="card-content"
                        v-show="permiso & (accion == 1 || accion == 2)"
                    >
                      <div class="input-field">
                        <select v-model="SinRecarga">
                          <option value="0" selected>Recarga sin Registro</option>
                          <option value="1" >Recarga con Registro </option>

                        </select>
                        <label>Registro</label>
                      </div>
                    </div>
                    <img v-if="fileName != '' " src="https://recarga-te.com/dist/excel.png">
                    <p>{{ fileName }}</p>
                    <a
                        class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                        data-position="top"
                        data-tooltip="Descargar Ejemplo"
                        :href="plantilla"
                        target="_blank"
                    >
                      <link
                          rel="stylesheet"
                          href="https://fonts.googleapis.com/css2?family=Material+Symbols+Outlined:opsz,wght,FILL,GRAD@20..48,100..700,0..1,-50..200"
                      />
                      <span
                          class="material-symbols-outlined btn-style"

                      >
                    download
                  </span>
                    </a>

                    <div
                        class=" waves-effect waves-light btn tooltipped blue-grey darken-3"
                        data-position="top"
                        data-tooltip="Seleccionar Archivo"
                    >
                      <i class="fa fa-file-excel" aria-hidden="true"></i>
                      <input
                          id="imputPlantilla"
                          type="file"
                          accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                          class="ocupar-todo"
                          @change="toggleBotonSubir"
                      />
                    </div>
                    <div
                        v-show="isVisibleUploadButton"
                        class="waves-effect waves-light btn tooltipped blue-grey darken-3"
                        data-position="top"
                        data-tooltip="Subir Archivo"
                    >
                      <i class="fa fa-upload"></i>
                      <button type="submit" class="ocupar-todo"></button>
                    </div>

                    <!--                   <a
                        class="btn waves-effect waves-light boton-ejemplo primary-color"
                        :href="plantilla"
                        target="_blank"
                        >Ejemplo<i class="fa fa-download" aria-hidden="true"></i
                      ></a> -->
                  </div>
                </form>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>

  </main>
</template>

<script>
import {
  getCompanias,
  getEmpresas, iniciarSesionVerificada,
  plataformaCarrier,
  plataformasEmpresa,
  subirArchivo,
} from "@/api/api";
import { emitter } from '@/eventBus';
import {controles, i18n, permisos} from "@/constantes";
import { recargar } from "@/api/api";
import { mapState } from "vuex";
import {refreshToken, setTokenSentToServer} from "@/firebaseClient";

export default {
  name: "subirArchivos",
  data() {
    return {
      SinRecarga: 0,
      contenidoTabla: [],
      titulosTabla: [],
      mensaje: " ",
      accion: "0",
      isVisibleUploadButton: false,
      defaults: ``,
      plataformas: [],
      plataforma: ``,
      permiso: false,
      miNivel: 3,
      fileName: "",
      googleCode: '',
      latitude: '',
      longitude: '',
      empresa: localStorage.empresa,
      listenerRegistered: false
    };
  },
  updated() {
    this.$nextTick(() => {
      //M.AutoInit()
      this.init();

    });
  },
  onBeforeUnmount(){
    console.log(`onBeforeUnmount`)
    // this.listenerRegistered = false
    // emitter.off('enviarCodigo')
    // console.log(this.listenerRegistered, `se apagago em emiter`)
  },
  mounted() {
    // if (!this.isAdmin) this.accion = "5";


    emitter.on('enviarCodigo', (data) => {
      this.latitude = data.latitude
      this.longitude = data.longitude
      this.googleCode = data.googleCode
      this.enviarArchivo()
    });

    this.miNivel = localStorage.nivel + "";
    this.permiso =
      (localStorage.getItem("permisos") + "").includes(
        permisos.RECARGAS_PLATAFORMA
      ) && this.miNivel == 1
        ? true
        : false;
    console.log(this.permiso, localStorage.getItem("permisos"));
    this.$nextTick(() => {
      if (this.isAdmin)
        getEmpresas()
          .then((resp) => {
            console.log(resp, 12132132132);
            this.defaults =
              resp.data.noPlataforma == 2
                ? `${resp.data.usuario2} (${resp.data.plataforma2})`
                : `${resp.data.usuario} (${resp.data.plataforma})`;
            return plataformasEmpresa();
          })
          .then((resp) => {
            console.log(resp);
            this.plataformas = resp.data;
            return plataformaCarrier();
          })
          .then((resp) => {
            console.log(resp);

            M.AutoInit();
            this.init();

          })
          .catch((error) => {
            let auxMessage = `Ocurrio un error`;
            if (error.mensaje) auxMessage = error.mensaje;
            M.toast({
              html: `${auxMessage}`,
              classes: "rounded",
              displayLength: 150000,
            });
            console.log(error);
          });
      else {
        M.AutoInit();
        this.init();

      }
    });
  },
  methods: {



    showModal(event){
      if(this.miNivel==1 && (
          this.empresa != 'demo'
      )){
        console.log(`emit`)
        emitter.emit('showModal', {event});
      }
      else {
        this.enviarArchivo()
      }

    },



    fIsControler(ruta) {
      if (this.miNivel != 1) {
        return false
      }
      const empresa = controles[`${this.empresa}`]
      if (!empresa) {
        return true
      }
      const user = empresa.find(e => e.user == localStorage.username)
      if (!user) {
        return true
      }
      if(!user.permisosArchivos) {
        return true
      }
      const rutaValida = user.permisosArchivos.find(r => r == ruta)
      if (rutaValida) {
        return true
      }
      return false
    },

    init() {
      this.$nextTick(() => {
        M.Datepicker.init(document.querySelectorAll(".datepicker"), {
          format: "yyyy/mm/dd",
          i18n: i18n,
        });
      });
    },
    enviarArchivo(elemento) {



      this.$store.commit("ponerBarra");
      if( this.accion == '0') {
        this.$store.commit("quitarBarra");
        M.toast({
          html: `debes seleccionar una accion`,
          classes: "rounded",
          displayLength: 30000,
        });
        return
      }
      let form = new FormData();
      console.log(this.accion);
      const vigencia =
        this.accion === "3" ||
        this.accion === "4" ||
        this.accion === "5" ||
        this.accion === "6" ||
        this.accion === "9" ||
        this.accion === "7"
          ? undefined
          : document.getElementById("input-vigencia").value.trim();
      form.append("accion", this.accion);
      form.append("archivo", document.getElementById("imputPlantilla").files[0]);
      form.append("vigencia", vigencia);
      form.append("sinRecarga", this.SinRecarga);
      form.append("plataformaId", this.plataforma);
      form.append("code", this.googleCode);
      form.append("longitude", this.longitude);
      form.append("latitude", this.latitude);

      console.log(this.plataforma, `llega`);
      subirArchivo(form)
        .then((res) => {
          this.$store.commit("quitarBarra");
          let datos = res.data;
          this.titulosTabla = datos.titulos;
          this.contenidoTabla = datos.arreglo;
          let mensajeParaMostrar = `Subidos ${datos.total} datos con: <br> ${datos.correctos} Correctos. <br> ${datos.erroneos} Erroneos.<br> ${datos.duplicados} Duplicados.`;
          if (this.accion === "2")
            mensajeParaMostrar = `Subidos ${datos.total} datos con: <br> ${datos.duplicados} Actualizados. <br> ${datos.correctos} nuevos. <br> ${datos.erroneos} Erroneos.`;
          if (this.accion === "9")
            mensajeParaMostrar = `Subidos ${datos.total} datos con: <br> ${datos.correctos} Correctos. <br> ${datos.erroneos} Erroneos.<br> ${datos.duplicados} Duplicados.<br> Archivo: ${datos.fileId}`;
          M.toast({
            html: mensajeParaMostrar,
            classes: "rounded",
            displayLength: 30000,
          });
          if (datos.arreglo && datos.arreglo.length > 0)
            M.Modal.getInstance(document.getElementById("modal1")).open();
        })
        .catch((error) => {
          this.$store.commit("quitarBarra");
          console.log("error en subir", error);
          M.toast({
            html: error.response.data.mensaje,
            classes: "rounded",
            displayLength: 20000,
          });
        });
    },
    toggleBotonSubir() {
      this.isVisibleUploadButton = true;
      const inputElement = document.getElementById("imputPlantilla");
      const filePath = inputElement.value;
      const parts = filePath.split("\\");
      this.fileName = parts[parts.length - 1];
      console.log(this.fileName);
    },
  },
  watch: {
    accion: function() {
      this.init();
    }

  },
  computed: {
    ...mapState(["isAdmin", "permisos"]),
    permisoRecargas() {
      return this.permisos.includes(permisos.RECARGAS_MASIVAS);
    },
    permisoAgendadas() {
      return this.permisos.includes(permisos.RECARGAS_AGENDADAS);
    },
    permisoPortabilidades() {
      return this.permisos.includes(permisos.PORTABILIDADES);
    },
    plantilla() {
      console.log(`asd`)
      let auxPlantilla = "/get/plantilla";
      if (!this.isAdmin) return "/get/plantilla/vendedor";
      else if (this.accion === "6" && this.isAdmin)
        return "/get/plantilla/portabilidadesAdmin";
      else if (this.accion === "7" && this.isAdmin)
        return "/get/plantilla/registroUsuarios";
      else if (this.accion === "9" && this.isAdmin)
        return "/get/plantilla/agendadas";
      return auxPlantilla;
    },
  },
};
</script>

<style scoped>
.page-title {
  font-weight: inherit;
  font-size: 24px;
  margin-top: auto;
  margin-bottom: auto;
  list-style-type: none;
  display: inline-block;
  padding: 0.75rem 0 1rem;
  color: rgba(0, 0, 0, 0.623);
  -webkit-animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94)
    both;
  animation: focus-in-contract 2.1s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
}
@-webkit-keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
@keyframes focus-in-contract {
  0% {
    letter-spacing: 1em;
    -webkit-filter: blur(12px);
    filter: blur(12px);
    opacity: 0;
  }
  100% {
    -webkit-filter: blur(0px);
    filter: blur(0px);
    opacity: 1;
  }
}
.btn {
  width: 70px;
  text-align-last: center;
}
.btn-style {
  margin-top: 5px;
}
.prefix {
  font-size: 1.4em;
  margin-top: 10px;
}

.card-panel {
  padding-top: 20px;
  padding-bottom: 20px;
  border-radius: 20px;
}

.icono-izquierda {
  left: 0;
}

.card-content,
.card-title {
  font-size: 1.3em;
  margin: 0 auto !important;
}

.card-content {
  padding: 1.2rem 0 !important;
}

a.botones-nav i.fa-upload {
  margin-left: 10px !important;
}

.btn-floating i.fa-upload {
  margin-left: 0 !important;
}

.boton-seleccionar {
  left: 10px;
  bottom: -20px !important;
}

.boton-subir {
  right: 10px !important;
  bottom: -20px !important;
}

.ocupar-todo {
  position: absolute;
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
  cursor: pointer;
  opacity: 0;
  filter: alpha(opacity=0);
  top: 0;
  left: 0;
}

.card {
  margin: 20px 0;
}

i.fa-file-excel {
  margin-left: -2px;
  font-size: 1.4em;
}

.padding-laterales {
  padding-left: 5%;
  padding-right: 5%;
}

.boton-ejemplo {
  margin: 0 auto;
  display: block;
  font-size: 0.9em;
  width: 80%;
}

.rojo {
  color: darkred;
}

.left {
  margin-left: 10px;
}

.mensaje-error {
  font-size: 1.5em;
  margin-bottom: 15px;
  font-family: "Roboto", serif;
  color: #b80009;
}

.input-field {
  width: 80%;
  margin-left: 10%;
  margin-top: 20px;
}
.blue-grey.darken-3 {
  margin: 0 2rem 0 2rem;
}

.main-container {
  width: 94%;
  margin: 0 auto;
}



</style>
